import axios from '../axios';


export class AuthenticationError extends Error {
  response = null;
  constructor(message, response) {
    super(message);
    this.response = response;
  }
}

export class LockoutError extends Error {
  response = null;
  constructor(message, response) {
    super(message);
    this.response = response;
  }
}

export default {

  async getCSRFToken(lang) {
    let user_lang = lang;
    const res = await axios().post('portal/loginCSRF', {
      user_lang,
    })
    if(res.data.STATUS !== true) {
      throw new Error('Network Error, please Refresh the page or Try again later');
    }
  },

  async login(user) {
    
    const res = await axios().post(`portal/login`, {
      email: user.email,
      password: user.password
    })

    if(res.status == 423) {
      throw new LockoutError(res.data.Msg, res.data);
    }   

    if (res.data.STATUS !== true) {
      this.logout();
      throw new AuthenticationError(res.data.Msg, res.data)
    }

  },

  async getUserData() {
    

    const res = await axios().get(`portal/userData`)
    
    if(res.data.STATUS === false && res.data.CODE === -120) {
      throw new Error(res.data.DESC)
    }

    if (res.data.STATUS === false || res.data.CODE == -8 || res.data.CODE == -9) {
      this.logout();
      return;
    }

    const data = await res.data.Data

    if (data[0].pk !== null) {
      let d = new Date();
      d.setTime(d.getTime() + 3600 * 1000);
      let expires = "expires=" + d.toUTCString();
      let lang = data[0].lang == '1' ? 1 : 2
      document.cookie =
        "user_id=" + data[0].pk + ";" + expires + ";path=/";
      document.cookie =
        "lang=" + lang + ";" + expires + ";path=/";
    }
  },

  logout() {
    return axios().post(`portal/logout`)
    .then(res => {
      document.cookie = "user_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "lang=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    })
    .catch(err => {
      document.cookie = "user_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie = "lang=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    })
  }
};